import {ACTION_TYPE} from "utils/constants";

const initialState = {
  isOpen: false,
  alertType: "",
  options: {
    closeButton: true,
    dismissOverlay: false,
    invisibleOverlay: false,
    defaultPadding: true,
    darkmode: true,
  },
  props: {},
};

const alertPopup = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPE.OPEN_ALERT:
      return {
        isOpen: true,
        alertType: action.alertType,
        options: {
          ...initialState.options,
          ...action.options,
        },
        props: action.props,
      };
    case ACTION_TYPE.CLOSE_ALERT:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default alertPopup;
